import React, { useEffect, useState, useCallback } from "react";
import AuthorisedDistributorsList from "./AuthorisedDistributorsList/AuthorisedDistributorsList";
import DropdownWithSearch from "./DropdownWithSearch/DropdownWithSearch";
import axios from 'axios';
import debounce from "lodash.debounce";

export default function AuthorisedDistributors() {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countries, setCountries] = useState([]);
    const [items, setItems] = useState([]);
    const [searchInputValue, setSearchInputValue] = useState("");
    const [distributorsLoading, setDistributorsLoading] = useState(false);

    const apiUrl = '/api/AuthorisedDistributors/';

    function fetchCountries(query = "") {
        const url = `${apiUrl}GetRelatedCountries`
        const params = {
            countryName: query
        };

        axios.get(url, {params: params})
            .then(result => {
                setCountries(result.data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    function fetchDistributorsForCountry() {
        const url = `${apiUrl}GetByCountryId`
        const params = {
            countryid: selectedCountry.Id
        };
        setDistributorsLoading(true);

        axios.get(url, {params: params})
            .then(result => {
                setItems(result.data);
                setDistributorsLoading(false);
            })
            .catch((error) => {
                setItems([]);
                setDistributorsLoading(false);
                console.error('Error:', error);
            });
    }

    function handleSearchInputValueChange(event) {
        event.preventDefault();
        setSearchInputValue(event.target.value);
        fetchCountriesDebounced(event.target.value);
    }

    function handleSearchInputValueClear(event) {
        event.preventDefault();
        setSearchInputValue("");
        fetchCountriesDebounced("");
    }

    const handleOptionSelect = (option) => {
        setSelectedCountry(option);
    }

    const fetchCountriesDebounced = useCallback(
        debounce((query) => {
            fetchCountries(query);
        }, 250),
        []
    );
   
    useEffect(()=> {
        fetchCountriesDebounced();
    }, [])

    useEffect(() => {
        if(selectedCountry) {
            fetchDistributorsForCountry();
        }
    }, [selectedCountry])


    return (
        <>
            <DropdownWithSearch
                options={countries}
                handleOptionSelect={handleOptionSelect}
                selectedOption={selectedCountry}
                searchQuery={searchInputValue}
                handleSearchInputValueChange={handleSearchInputValueChange}
                handleSearchInputValueClear={handleSearchInputValueClear}
                placeholder="Select country"
            />
            {selectedCountry && <AuthorisedDistributorsList items={items} isLoading={distributorsLoading} />}
        </>
    )
}
